import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  ReferenceInput,
  required,
} from 'react-admin';
import { Grid } from '@mui/material';

const statusChoices = [
  { id: 'active', name: 'Active' },
  { id: 'inactive', name: 'Inactive' },
  { id: 'completed', name: 'Completed' },
];

const userStatusChoices = [
  { id: 'owner', name: 'Owner' },
  { id: 'operator', name: 'Operator' },
  { id: 'employee', name: 'Employee' },
  { id: 'contractor', name: 'Contractor' },
];

const modeChoices = [
  { id: 'full_time', name: 'Full Time' },
  { id: 'part_time', name: 'Part Time' },
  { id: 'seasonal', name: 'Seasonal' },
  { id: 'temporary', name: 'Temporary' },
];

export const DriverVehicleCreate = () => (
  <Create>
    <SimpleForm>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <ReferenceInput source="driverId" reference="drivers">
            <SelectInput optionText={(record: any) => record?.user?.name ? `${record.user.name} (Driver ID: ${record.id})` : `Driver ID: ${record?.id}`} validate={required()} fullWidth />
          </ReferenceInput>
        </Grid>
        <Grid item xs={12} md={6}>
          <SelectInput 
            source="status" 
            choices={statusChoices}
            defaultValue="active"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="jobVehicleYear" label="Year" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="jobVehicleMake" label="Make" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="jobVehicleModel" label="Model" fullWidth />
        </Grid>
        <Grid item xs={12} md={6}>
          <SelectInput 
            source="jobVehicleUserStatus" 
            label="User Status"
            choices={userStatusChoices}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <NumberInput source="lengthMonths" label="Duration (Months)" fullWidth />
        </Grid>
        <Grid item xs={12} md={6}>
          <SelectInput 
            source="mode" 
            choices={modeChoices}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput source="typeOther" label="Other Vehicle Type" fullWidth />
        </Grid>
        <Grid item xs={12}>
          <TextInput source="notes" multiline rows={3} fullWidth />
        </Grid>
      </Grid>
    </SimpleForm>
  </Create>
);